/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WindroseSpeedBucket } from './WindroseSpeedBucket';
import {
    WindroseSpeedBucketFromJSON,
    WindroseSpeedBucketFromJSONTyped,
    WindroseSpeedBucketToJSON,
    WindroseSpeedBucketToJSONTyped,
} from './WindroseSpeedBucket';

/**
 * 
 * @export
 * @interface WindroseDirectionBucket
 */
export interface WindroseDirectionBucket {
    /**
     * 
     * @type {Array<WindroseSpeedBucket>}
     * @memberof WindroseDirectionBucket
     */
    speedBuckets: Array<WindroseSpeedBucket>;
}

/**
 * Check if a given object implements the WindroseDirectionBucket interface.
 */
export function instanceOfWindroseDirectionBucket(value: object): value is WindroseDirectionBucket {
    if (!('speedBuckets' in value) || value['speedBuckets'] === undefined) return false;
    return true;
}

export function WindroseDirectionBucketFromJSON(json: any): WindroseDirectionBucket {
    return WindroseDirectionBucketFromJSONTyped(json, false);
}

export function WindroseDirectionBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): WindroseDirectionBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'speedBuckets': ((json['speedBuckets'] as Array<any>).map(WindroseSpeedBucketFromJSON)),
    };
}

export function WindroseDirectionBucketToJSON(json: any): WindroseDirectionBucket {
    return WindroseDirectionBucketToJSONTyped(json, false);
}

export function WindroseDirectionBucketToJSONTyped(value?: WindroseDirectionBucket | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'speedBuckets': ((value['speedBuckets'] as Array<any>).map(WindroseSpeedBucketToJSON)),
    };
}

